import useCurrentIdentity from "utilities/hooks/use-current-identity";
import { CoreUtils } from "@rsm-hcd/javascript-core";
import NotebookRecord from "models/view-models/notebook-record";
import IdentityRecord from "models/view-models/identity-record";
import useFeatureFlags from "utilities/hooks/use-feature-flags";

export enum NotebookAction {
    Open = 1,
    Delete = 2,
    Rename = 3,
    Share = 4,
    CreatePage = 5,
}
const FEATURE_FLAGGED_ACTIONS = [NotebookAction.Share];
const ALL_ACTIONS = CoreUtils.enumToArray(NotebookAction).filter(
    (action) => !FEATURE_FLAGGED_ACTIONS.includes(action)
);
const BASE_ACTIONS = [NotebookAction.Open];

const useNotebookActionPermission = (
    notebook: NotebookRecord | null | undefined
) => {
    const { currentIdentity } = useCurrentIdentity();
    const { allowNotebookCollaboration } = useFeatureFlags();

    const permissions = buildPermissions(
        notebook,
        currentIdentity,
        allowNotebookCollaboration
    );

    const can = (action: NotebookAction) => {
        return permissions.includes(action);
    };
    const hasOnlyBasePermissions = () => {
        return (
            permissions.length === BASE_ACTIONS.length &&
            BASE_ACTIONS.every((action) => permissions.includes(action))
        );
    };

    return {
        permissions,
        can,
        hasOnlyBasePermissions,
    };
};

const buildPermissions = (
    notebook: NotebookRecord | null | undefined,
    currentIdentity: IdentityRecord | undefined,
    sharingAllowed: boolean
) => {
    const isOwner = notebook?.ownerId === currentIdentity?.userId();
    const permissions =
        isOwner && !!notebook?.isSharedPagesNotebook
            ? [...ALL_ACTIONS]
            : [...BASE_ACTIONS];

    if (sharingAllowed && isOwner && currentIdentity?.isGroupMember()) {
        permissions.push(NotebookAction.Share);
    }

    return permissions;
};

export default useNotebookActionPermission;
